import attachmentsList from './modules/store'

export const modules = {
  attachmentsList
}



// WEBPACK FOOTER //
// ./src/store/Attachments/index.js